<template>
  <v-container>
    <div class="d-flex flex-column mt-4">
      <h3>WDP Erfüllung</h3>
    </div>

    <span>Arbeitszeit</span>
    <div><strong class="mb-2">gesamt: {{workTime}}</strong></div>

    <span>Freie Tage</span>
    <v-progress-linear
        class="bg-white"
        v-model="freeDays"
        :max="freeDaysMax"
        height="25"
        color="green"
    >
    </v-progress-linear>
    <div><strong class="mb-2">{{freeDays}}/{{freeDaysMax}} ({{ freeDays > 0 ? Math.ceil((freeDays / freeDaysMax) * 100) : 0 }}%) - {{freeDaysService}} </strong></div>

    <span>Frühschicht</span>
    <v-progress-linear
        class="bg-white"
        v-model="earlyDays"
        :max="earlyDaysMax"
        height="25"
        color="orange"
    >
    </v-progress-linear>
    <div><strong class="mb-2">{{earlyDays}}/{{earlyDaysMax}} ({{ earlyDays > 0 ? Math.ceil((earlyDays / earlyDaysMax) * 100) : 0 }}%) - {{earlyDaysService}} </strong></div>

    <span>Mittelschicht</span>
    <v-progress-linear
        class="bg-white"
        v-model="middleDays"
        :max="middleDaysMax"
        height="25"
        color="pink"
    >
    </v-progress-linear>
    <div><strong class="mb-2">{{middleDays}}/{{middleDaysMax}} ({{ middleDays > 0 ? Math.ceil((middleDays / middleDaysMax) * 100) : 0 }}%) - {{middleDaysService}} </strong></div>

    <span>Spätschicht</span>
    <v-progress-linear
        class="bg-white"
        v-model="lateDays"
        :max="lateDaysMax"
        height="25"
        color="purple"
    >
    </v-progress-linear>
    <div><strong class="mb-2">{{lateDays}}/{{lateDaysMax}} ({{ lateDays > 0 ? Math.ceil((lateDays / lateDaysMax) * 100) : 0 }}%) - {{lateDaysService}} </strong></div>

    <span>Geteilter Dienst</span>
    <v-progress-linear
        class="bg-white"
        v-model="sharedDays"
        :max="sharedDaysMax"
        height="25"
        color="teal"
    >
    </v-progress-linear>
    <div><strong class="mb-2">{{sharedDays}}/{{sharedDaysMax}} ({{ sharedDays > 0 ? Math.ceil((sharedDays / sharedDaysMax) * 100) : 0 }}%) - {{sharedDaysService}} </strong></div>

    <span>Nachtexpress</span>
    <v-progress-linear
        class="bg-white"
        v-model="nightExpressDays"
        :max="nightExpressDaysMax"
        height="25"
        color="blue"
    >
    </v-progress-linear>
    <div><strong class="mb-2">{{nightExpressDays}}/{{nightExpressDaysMax}} ({{ nightExpressDays > 0 ? Math.ceil((nightExpressDays / nightExpressDaysMax) * 100) : 0 }}%) - {{nightExpressDaysService}} </strong></div>
    
    <span>Urlaub</span>
    <v-progress-linear
        class="bg-white"
        v-model="vacationDays"
        :max="vacationDaysMax"
        height="25"
        color="green"
    >
    </v-progress-linear>
    <div><strong class="mb-2">{{vacationDays}}/{{vacationDaysMax}} ({{ vacationDays > 0 ? Math.ceil((vacationDays / vacationDaysMax) * 100) : 0 }}%) - {{vacationDaysService}} </strong></div>
    
    <span>Verfügung</span>
    <v-progress-linear
        class="bg-white"
        v-model="availableDays"
        :max="availableDaysMax"
        height="25"
        color="lightblue"
    >
    </v-progress-linear>
    <div><strong class="mb-2">{{availableDays}}/{{availableDaysMax}} ({{ availableDays > 0 ? Math.ceil((availableDays / availableDaysMax) * 100) : 0 }}%) - {{availableDaysService}} </strong></div>

    <span>Gesamt</span>
    <v-progress-linear
        class="bg-white"
        v-model="total"
        :max="totalMax"
        height="25"
        color="gray"
    >
    </v-progress-linear>
    <div><strong class="mb-2">{{total}}/{{totalMax}} ({{ total > 0 ? Math.ceil((total / totalMax) * 100) : 0 }}%) </strong></div>
  </v-container>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, watch, ref} from "vue"
import {GetWishData} from "@/data/wishData"
import {GetEmployServiceDataDate, GetEmployVacationData} from "@/data/employData"
//import {getNormalizedService} from "@/data/userData"
import { convertUtcToGermanLocal, sumTimeStrings, getNormalizedService } from "@/hooks/utils"

export default defineComponent({
  name: "WorkStatistic",
  setup(props) {
    const wishPeriod = computed(() => props.wishPeriod)
    const userData = computed(() => props.userData)
    console.log("WISHPERIOD-User", wishPeriod.value, userData.value)
    const fullEmployWishData = ref(null)
    const employServiceData = ref(null)

    const freeDays = ref(0)
    const freeDaysService = ref(0)
    const freeDaysMax = ref(0)
    const earlyDays = ref(0)
    const earlyDaysService = ref(0)
    const earlyDaysMax = ref(0)
    const middleDays = ref(0)
    const middleDaysService = ref(0)
    const middleDaysMax = ref(0)
    const lateDays = ref(0)
    const lateDaysService = ref(0)
    const lateDaysMax = ref(0)
    const sharedDays = ref(0)
    const sharedDaysService = ref(0)
    const sharedDaysMax = ref(0)
    const nightExpressDays = ref(0)
    const nightExpressDaysService = ref(0)
    const nightExpressDaysMax = ref(0)
    const vacationDays = ref(0)
    const vacationDaysService = ref(0)
    const vacationDaysMax = ref(0)
    const total = ref(0)
    const totalMax = ref(0) 
    const availableDays = ref(0)
    const availableDaysService = ref(0)
    const availableDaysMax = ref(0)
    const workTime = ref("")

    watch(() => [wishPeriod, userData], async ([newWishPeriod, newUserData]) => {
      console.log("STATISTIK USER", newUserData.value, newWishPeriod.value)
      if (!newUserData.value || !newWishPeriod.value) return
      freeDays.value = 0
      freeDaysService.value = 0
      freeDaysMax.value = 0
      earlyDays.value = 0
      earlyDaysService.value = 0
      earlyDaysMax.value = 0
      middleDays.value = 0
      middleDaysService.value = 0
      middleDaysMax.value = 0
      lateDays.value = 0
      lateDaysService.value = 0
      lateDaysMax.value = 0
      sharedDays.value = 0
      sharedDaysService.value = 0
      sharedDaysMax.value = 0
      nightExpressDays.value = 0
      nightExpressDaysService.value = 0
      nightExpressDaysMax.value = 0
      vacationDays.value = 0
      vacationDaysService.value = 0
      vacationDaysMax.value = 0
      total.value = 0
      totalMax.value = 0 
      availableDays.value = 0
      availableDaysService.value = 0
      availableDaysMax.value = 0
      workTime.value = ""
      let workTimeArr: string[] = [];

      fullEmployWishData.value = null
//      employVacationData.value = null
      employServiceData.value = null

      const _userData = newUserData.value //await GetUserData(newUserData.value.sub)
      const _datefrom = convertUtcToGermanLocal(newWishPeriod.value.startDate)
      const _dateto = convertUtcToGermanLocal(newWishPeriod.value.endDate)
      fullEmployWishData.value = await GetWishData(newWishPeriod.value.id, _userData.EmployData?.emplno)
      employServiceData.value = await GetEmployServiceDataDate(_userData.EmployData?.emplno, _datefrom, _dateto)
//      employVacationData.value = await GetEmployVacationData(_userData.EmployData?.emplno)
      console.log("DATEN", employServiceData.value)
      for (const employservice of employServiceData.value) {
        let _serviceshift = getNormalizedService(employservice).split(',')[0]
        let _wishshift = employservice?.wish?.shift || 0
        let _vacation = employservice?.wish?.vacation || false
        switch (_wishshift.toString()) {
          case "1":
              earlyDaysMax.value++
              break
          case "2":
              middleDaysMax.value++
              break
          case "3":
              lateDaysMax.value++
              break
          case "4":
              nightExpressDaysMax.value++
              break
          case "5":
              sharedDaysMax.value++
              break
          case "10":
              freeDaysMax.value++
              break
          case "11":
              vacationDaysMax.value++
              break
          case "12":
              freeDaysMax.value++
              break
        }
        switch (_serviceshift) {
          case "1":
            earlyDaysService.value++
            if (_wishshift.toString() === _serviceshift)
              earlyDays.value++
            break
          case "2":
            middleDaysService.value++
            if (_wishshift.toString() === _serviceshift)
              middleDays.value++
            break
          case "3":
            lateDaysService.value++
            if (_wishshift.toString() === _serviceshift)
              lateDays.value++
            break
          case "4":
            nightExpressDaysService.value++
            if (_wishshift.toString() === _serviceshift)
              nightExpressDays.value++
            break
          case "5":
            sharedDaysService.value++
            if (_wishshift.toString() === _serviceshift)
              sharedDays.value++
            break
          case "10":
            freeDaysService.value++
            if (_wishshift.toString() === _serviceshift)
              freeDays.value++
            break
          case "11":
            vacationDaysService.value++
            if (_vacation)
                vacationDays.value++
//            vacationDaysMax.value++
            break
          case "12":
            freeDaysService.value++
            if (_vacation)
              freeDays.value++
//            freeDaysMax.value++
            break
          case "*":
            availableDaysService.value++
            break
        }
        if (employservice.work.trim() !== "") {
          workTimeArr.push(employservice.work.trim());
        }
      }
      total.value = freeDays.value + earlyDays.value + middleDays.value + lateDays.value + 
          sharedDays.value + nightExpressDays.value + vacationDays.value
      totalMax.value = freeDaysMax.value + earlyDaysMax.value + middleDaysMax.value + lateDaysMax.value + 
          sharedDaysMax.value + nightExpressDaysMax.value + vacationDaysMax.value
      workTime.value = sumTimeStrings(workTimeArr)
    }, {deep: true, immediate: true})
    
    return {wishPeriod, freeDays, freeDaysService, freeDaysMax, earlyDays, earlyDaysService, earlyDaysMax, 
      middleDays, middleDaysService, middleDaysMax, lateDays, lateDaysService,
      lateDaysMax, sharedDays, sharedDaysService, sharedDaysMax,
      nightExpressDays, nightExpressDaysService, nightExpressDaysMax, 
      vacationDays, vacationDaysService, vacationDaysMax, total, totalMax, 
      availableDays, availableDaysMax, availableDaysService, workTime}
  },
  props: {
    wishPeriod: {
      type: Object,
      default: null,
    },
    userData: {
      type: Object,
      default: null,
    },
    ruleBreaks: {
      type: Array,
      default: null,
    }
  },
  emits: ['dayclick'],
  methods: {
    dayClick(date) {
      this.$emit('dayclick', date);
    }
  }
})
</script>